const darkModeMediaQuery = '(prefers-color-scheme: dark)';

export const getSystemPreferredColorScheme = (): 'light' | 'dark' => {
	const isMatchMediaAvailable = typeof window !== 'undefined' && 'matchMedia' in window;
	const darkModeMql = isMatchMediaAvailable && window.matchMedia(darkModeMediaQuery);

	return darkModeMql && darkModeMql.matches ? 'dark' : 'light';
};
